export { FirstType } from "./firts-type";
